<script lang="ts">import { cfgBrandTitle, cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
const BRAND_NAME = cfgBrandTitle();
const bgSrc = cfgToThemeCdnPath("/about-vip/modern/reason-bg.png");
const chartSrc = cfgToThemeCdnPath("/about-vip/modern/reason-chart.png");
const logoSrc = cfgToThemeCdnPath("/misc/logo.svg");
</script>

<InfoCard
	modernStyle
	modernBordered
	modernGlowPosition="right"
	width="100%"
	noPadding
	borderRadius="20px"
	customClass="vip-reason-card"
>
	<div class="vip-reason">
		<div class="vip-reason-visual">
			<img class="vip-reason-bg" src={bgSrc} alt={$t(Verbiage.illustration_alt, 'alts')} />

			<InfoCard
				modernStyle
				modernGlowPosition="bottom"
				noPadding
				borderRadius="16px"
				customClass="vip-reason-chart-card"
			>
				<div class="vip-reason-chart">
					<div class="vip-reason-legend">
						<div class="vip-reason-legend-item">
							<span class="vip-reason-swatch vip-reason-swatch-payouts"></span>
							<Text
								type="body"
								bodySize="small"
								bodyWeight="semibold"
								textColor="white"
								className="vip-reason-legend-label"
							>
								{$t(Verbiage.vip_modern_payouts)}
							</Text>
						</div>
						<div class="vip-reason-legend-item">
							<span class="vip-reason-swatch vip-reason-swatch-marketing"></span>
							<Text
								type="body"
								bodySize="small"
								bodyWeight="semibold"
								textColor="white"
								className="vip-reason-legend-label"
							>
								{$t(Verbiage.vip_modern_marketing)}
							</Text>
						</div>
					</div>

					<img
						class="vip-reason-chart-bars"
						src={chartSrc}
						alt={$t(Verbiage.illustration_alt, 'alts')}
					/>

					<div class="vip-reason-chart-axis">
						<Text
							type="body"
							bodySize="small"
							bodyWeight="semibold"
							className="vip-reason-axis-label"
						>
							{$t(Verbiage.vip_modern_other_casinos)}
						</Text>
						<img
							class="vip-reason-chart-logo"
							src={logoSrc}
							alt={$t(Verbiage.site_logo_alt, 'alts')}
						/>
					</div>
				</div>
			</InfoCard>
		</div>

		<div class="vip-reason-content">
			<VipModernEyebrow text={$t(Verbiage.vip_modern_why)} />
			<Text
				type="title"
				titleSize="h4"
				titleWeight="bold"
				textColor="white"
				className="vip-reason-title"
			>
				{$t(Verbiage.vip_modern_reason_title)}
			</Text>
			<Text type="body" bodySize="large" className="vip-reason-body">
				{$t(Verbiage.vip_modern_reason_body)}
			</Text>

			<div class="vip-reason-cash-rewards">
				<Text type="title" titleSize="h6" titleWeight="bold" textColor="white">
					{$t(Verbiage.vip_modern_cash_rewards)}
				</Text>
				<Text type="body" bodySize="small" textColor="gray">
					{$t(Verbiage.vip_modern_what_does_that_actually_mean_when_you_play_at_brand).replace(
						'[BRAND]',
						BRAND_NAME
					)}
				</Text>
				<Text type="body" bodySize="small" textColor="gray" bodyWeight="semibold">
					{$t(Verbiage.vip_modern_always_cash_rewards_no_wagering)}
				</Text>
				<Text type="body" bodySize="small" textColor="gray">
					{$t(Verbiage.vip_modern_cash_rewards_body)}
				</Text>
			</div>
		</div>
	</div>
</InfoCard>

<style>
	:global(.vip-reason-card) {
		min-height: 653px
}

	.vip-reason {
		position: relative;
		display: flex;
		min-height: 653px;
		width: 100%;
		flex-direction: column
}

	.vip-reason-visual {
		position: relative;
		display: flex;
		min-height: 320px;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		padding-left: 1.5rem;
		padding-right: 1.5rem;
		padding-top: 2rem;
		padding-bottom: 1.5rem
}

	.vip-reason-bg {
		position: absolute;
		top: 50%;
		left: 50%;
		-o-object-fit: contain;
		   object-fit: contain;
		opacity: 0.8;
		height: auto;
		max-height: 543px;
		width: 543px;
		--tw-translate-x: -50%;
		--tw-translate-y: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

	:global(.vip-reason-chart-card) {
		position: relative;
		z-index: 1;
		width: 100%;
		max-width: 370px
}

	.vip-reason-chart {
		display: flex;
		min-height: 330px;
		width: 100%;
		flex-direction: column;
		justify-content: space-around;
		gap: 0.5rem;
		padding: 1rem
}

	.vip-reason-legend {
		display: flex;
		flex-direction: column;
		gap: 0.5rem
}

	.vip-reason-legend-item {
		display: flex;
		align-items: center;
		gap: 0.5rem
}

	.vip-reason-swatch {
		display: block;
		height: 0.75rem;
		width: 0.75rem;
		flex-shrink: 0;
		border-radius: 3px
}

	.vip-reason-swatch-payouts {
		background-color: var(--color-accent-100)
}

	.vip-reason-swatch-marketing {
		background-color: var(--color-primary-500)
}

	:global(.vip-reason-legend-label) {
		text-transform: uppercase;
		letter-spacing: 0.025em
}

	.vip-reason-chart-bars {
		height: auto;
		width: 100%;
		-o-object-fit: contain;
		   object-fit: contain
}

	.vip-reason-chart-axis {
		display: flex;
		align-items: center;
		justify-content: space-around
}

	:global(.vip-reason-axis-label) {
		text-transform: uppercase;
		letter-spacing: 0.025em;
		color: var(--color-primary-300) !important
}

	.vip-reason-chart-logo {
		height: 1rem;
		width: auto;
		max-width: 90px;
		-o-object-fit: contain;
		   object-fit: contain
}

	.vip-reason-content {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 1.5rem;
		padding-left: 1.5rem;
		padding-right: 1.5rem;
		padding-bottom: 2rem;
		text-align: left
}

	:global(.vip-reason-title) {
		max-width: 24rem;
		font-size: 32px !important
}

	:global(.vip-reason-body) {
		max-width: 30rem
}

	.vip-reason-cash-rewards {
		margin-top: 1rem;
		display: flex;
		width: 100%;
		max-width: 420px;
		flex-direction: column;
		gap: 0.75rem;
		border-top-right-radius: 1rem;
		border-bottom-right-radius: 1rem;
		padding: 1.25rem;
		border-width: 1px;
		border-color: var(--color-neutral-300);
		background-color: var(--color-background-700);
		border-left-width: 2px;
		border-left-color: var(--color-primary-500)
}

	@media (min-width: 1024px) {
		:global(.vip-reason-card .info-card-modern) {
				border-color: transparent !important
		}

		:global(.vip-reason-title) {
				font-size: 37px !important
		}

		.vip-reason {
				flex-direction: row;
				align-items: stretch
		}

		.vip-reason-visual {
				width: 55%;
				flex-shrink: 0;
				padding-left: 2rem;
				padding-right: 2rem;
				padding-top: 0px;
				padding-bottom: 0px;
			min-height: unset
		}

		.vip-reason-content {
				width: 45%;
				justify-content: center;
				padding-top: 2.5rem;
				padding-bottom: 2.5rem;
				padding-right: 2.5rem
		}
	}
</style>
